import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BP_PHONE } from "./common";

// -------------------------------

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // -------------------------------
  const header = document.querySelector(".header-js");
  const banner = document.querySelector(".banner-js");
  const bannerPoster = document.querySelector(".banner-poster-js");
  let headerBgGradient = false;

  if (banner && header) {
    if (bannerPoster) {
      headerBgGradient = true;
      header.classList.add("bg-gradient");
    } else {
      header.classList.add("bg-white");
    }
  }
  if (!banner && header) {
    header.classList.add("bg-white");
  }
  // -------------------------------

  const changeHeader = document.querySelector(".change-header-js");
  if (changeHeader && header) {
    ScrollTrigger.create({
      trigger: changeHeader,
      start: bannerPoster ? "top top" : "top+=200 top",
      // end: `bottom top`,
      invalidateOnRefresh: true,
      fastScrollEnd: true,
      onUpdate: ({ direction }) => {
        if (direction > 0) {
          header.classList.add("hidden");
          header.classList.remove("visible");
        } else {
          header.classList.add("visible");
          header.classList.remove("hidden");
        }
      },
      onEnter: () => {
        if (headerBgGradient) {
          if (bannerPoster) {
            header.classList.remove("bg-gradient");
            header.classList.add("bg-white");
          } else {
            setTimeout(() => {
              header.classList.remove("bg-gradient");
              header.classList.add("bg-white");
            }, 300);
          }
        }
        if (bannerPoster) {
          gsap.set(header, { autoAlpha: 1, delay: 0.3 });
        }
      },
      onLeaveBack: () => {
        header.classList.remove("visible");
        header.classList.remove("hidden");

        if (headerBgGradient) {
          header.classList.add("bg-gradient");
          header.classList.remove("bg-white");
        }
        if (bannerPoster) {
          gsap.set(header, { autoAlpha: 0 });
        }
      },
    });
  }
  // -------------------------------
  const changeHeaderBar = document.querySelector(".change-header-bar-js");
  const changeHeaderBarMobile = document.querySelector(
    ".change-header-bar-mobile-js"
  );

  const headerBar = document.querySelector(".header-bar-js");

  const isPhone = window.matchMedia(`(max-width: ${BP_PHONE}px)`);
  let st, stMob;
  const handlerResize = (e) => {
    if (e.matches) {
      if (changeHeaderBarMobile && headerBar) {
        stMob = ScrollTrigger.create({
          trigger: changeHeaderBarMobile,
          start: "top top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
          onEnter: () => {
            headerBar.classList.add("visible");
          },
          onEnterBack: () => {
            headerBar.classList.add("visible");
          },
          onLeave: () => {
            headerBar.classList.remove("visible");
          },
          onLeaveBack: () => {
            headerBar.classList.remove("visible");
          },
        });
      }

      st && st.kill();
     
    } else {
      if (changeHeaderBar && headerBar) {
        st = ScrollTrigger.create({
          trigger: changeHeaderBar,
          start: "top top",
          end: "bottom bottom",
          invalidateOnRefresh: true,
          onEnter: () => {
            headerBar.classList.add("visible");
          },
          onEnterBack: () => {
            headerBar.classList.add("visible");
          },
          onLeave: () => {
            headerBar.classList.remove("visible");
          },
          onLeaveBack: () => {
            headerBar.classList.remove("visible");
          },
        });
      }
      stMob && stMob.kill();

    }
  };

  isPhone.addEventListener("change", (e) => {
    handlerResize(e.target);
  });

  handlerResize(isPhone);

  // -------------------------------
});
